/* global firebase */
import { LOADING_UI, OPEN_SNACKBAR, UPDATE_INSTALLED_APP_DATA, SET_ERRORS } from "../types";
import { db } from "../../firebase/firebase";
import { serverTimestamp, unixTimestamp, getCurrentUserOrganizationRef, currentUserIsRole } from "./utils";
import { SUPER_ADMIN } from "../../utils/userRoles";

export const editDevice = ({ key, device, name, deviceGroupKey, notes }) => dispatch => {
  dispatch({ type: LOADING_UI, payload: true });
  const deviceGroupRef = db.doc("deviceGroups/" + deviceGroupKey);
  db.collection("devices")
    .doc(key)
    .update({ name, deviceGroupRef, notes });
};

export const sendActionToDevice = ({ action, deviceKey, message }) => dispatch => {
  db.collection("devices/" + deviceKey + "/actions")
    .add({
      action,
      timeSent: serverTimestamp()
    })
    .then(_ =>
      dispatch({
        type: OPEN_SNACKBAR,
        payload: {
          message,
          timestamp: unixTimestamp() // without timestamp the snackbar will not appear when resending the same message
        }
      })
    );
};

export const sendLaunchAppCommandToDevice = ({ deviceKey, packageName, message }) => dispatch => {
  db.collection("devices/" + deviceKey + "/actions")
    .add({
      action: "LAUNCH_APP",
      timeSent: serverTimestamp(),
      data: { packageName }
    })
    .then(_ =>
      dispatch({
        type: OPEN_SNACKBAR,
        payload: {
          message,
          timestamp: unixTimestamp()  // without timestamp the snackbar will not appear when resending the same message
        }
      })
    );
};

export const getInstalledAppVersion = (packageName) => dispatch => {
  let query = db.collectionGroup('installedApps');

  if (!currentUserIsRole(SUPER_ADMIN)) {
    query = query.where('organizationRef', '==', getCurrentUserOrganizationRef());
  }

  query.where('packageName', '==', packageName)
    .orderBy('versionCode').get()
    .then(function (querySnapshot) {
      // translate data into this format (for easy merging) {deviceId: {installedApps: { appId: data}}}
      let deviceToAppData = {};
      querySnapshot.forEach(function (doc) {
        let deviceId = doc.ref.parent.parent.id;
        let dataObj = { installedApps: {} };
        dataObj.installedApps[doc.id] = doc.data();
        deviceToAppData[deviceId] = dataObj;
      });
      dispatch({ type: UPDATE_INSTALLED_APP_DATA, payload: deviceToAppData });
    })
};


export const deleteDevice = ({ serial, dispatch }) => {
  dispatch({ type: LOADING_UI, payload: true });
  const unregisterDevice = firebase.functions().httpsCallable('unregisterDevice');
  unregisterDevice({ serial })
    .then(_ => {
      dispatch({ type: LOADING_UI, payload: false });
    })
    .catch(error => {
      console.log(error);
      dispatch({ type: LOADING_UI, payload: false });
      // dispatch({ type: SET_ERRORS, payload: error.message });
    });
};

